<div class="activity-dialog">
  <div class="dialog-header">
    <h3>Activity Check Results</h3>

    <div class="status-section">
      <div
        class="status-badge"
        [style.background-color]="getStatusColor(selectedFacility.last_request?.status)"
      >
        <mat-icon>{{ getStatusIcon(selectedFacility.last_request?.status) }}</mat-icon>
        Status: {{ selectedFacility.last_request?.status || 'Unknown' }}
      </div>
    </div>

    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    @if (selectedFacility) {
    <div class="activity-results">
      <!-- Facility Info Section -->
      <div class="facility-info-card">
        <div class="facility-header">
          <h4>{{ selectedFacility.ClinicName }}</h4>
          <div class="facility-id-badge">
            ID: {{ selectedFacility.FacilityID || selectedFacility.ID }}
          </div>
          <div
            class="approval-status"
            [class.approved]="selectedFacility.approved === 1"
            [class.not-approved]="selectedFacility.approved === 0"
          >
            {{ selectedFacility.approved === 1 ? 'Approved' : 'Not Approved' }}
          </div>
        </div>
        <div class="activity-period-table-container">
          <table class="activity-period-table">
            <thead>
              <tr>
                <th></th>
                <th>Received</th>
                <th>Sent</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Today</td>
                <td>{{ activityPeriods?.Today?.Received ?? 0 }}</td>
                <td>{{ activityPeriods?.Today?.Sent ?? 0 }}</td>
              </tr>
              <tr>
                <td>Last Month</td>
                <td>{{ activityPeriods?.LastMonth?.Received ?? 0 }}</td>
                <td>{{ activityPeriods?.LastMonth?.Sent ?? 0 }}</td>
              </tr>
              <tr>
                <td>Last 12 Months</td>
                <td>{{ activityPeriods?.Last12Months?.Received ?? 0 }}</td>
                <td>{{ activityPeriods?.Last12Months?.Sent ?? 0 }}</td>
              </tr>
              <tr>
                <td>
                  <input
                    type="date"
                    [(ngModel)]="customDateFrom"
                    (change)="onCustomDateRangeChange()"
                    style="margin-left: 8px; max-width: 120px"
                    placeholder="From"
                  />
                  <span style="margin: 0 4px">to</span>
                  <input
                    type="date"
                    [(ngModel)]="customDateTo"
                    (change)="onCustomDateRangeChange()"
                    style="max-width: 120px"
                    placeholder="To"
                  />
                </td>
                <td>{{ customPeriod?.Received ?? 0 }}</td>
                <td>{{ customPeriod?.Sent ?? 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Request Sections -->
        <div class="request-sections mb-5">
          <div class="request-section">
            <div class="section-title">
              <mat-icon>call_received</mat-icon>
              Last Request From Facility
            </div>
            @if (selectedFacility.last_request?.to_facility) {
            <div class="request-details">
              <div class="detail-item">
                <div class="label">Date Received</div>
                <div class="value">
                  {{ formatDate(selectedFacility.last_request.to_facility.date_received) }}
                </div>
              </div>
              <div class="detail-item time-ago">
                <div class="label">Time Ago</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_facility.inactivity }}
                </div>
              </div>
              @if (selectedFacility.last_request.to_facility.destination) {
              <div class="detail-item">
                <div class="label">Destination</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_facility.destination }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_facility.test_requested) {
              <div class="detail-item">
                <div class="label">Test Requested</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_facility.test_requested }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_facility.patient_name) {
              <div class="detail-item">
                <div class="label">Patient Name</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_facility.patient_name }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_facility.performer) {
              <div class="detail-item">
                <div class="label">Performer</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_facility.performer }}
                </div>
              </div>
              }
            </div>
            } @else {
            <div class="no-data">
              <mat-icon>info</mat-icon>
              No requests found from this facility
            </div>
            }
          </div>
          <div class="request-section">
            <div class="section-title">
              <mat-icon>call_made</mat-icon>
              Last Request To Group
            </div>
            @if (selectedFacility.last_request?.to_group) {
            <div class="request-details">
              <div class="detail-item">
                <div class="label">Date Sent</div>
                <div class="value">
                  {{ formatDate(selectedFacility.last_request.to_group.date_sent) }}
                </div>
              </div>
              <div class="detail-item time-ago">
                <div class="label">Time Ago</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_group.inactivity }}
                </div>
              </div>
              @if (selectedFacility.last_request.to_group.destination) {
              <div class="detail-item">
                <div class="label">Destination</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_group.destination }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_group.test_requested) {
              <div class="detail-item">
                <div class="label">Test Requested</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_group.test_requested }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_group.patient_name) {
              <div class="detail-item">
                <div class="label">Patient Name</div>
                <div class="value">
                  {{ selectedFacility.last_request.to_group.patient_name }}
                </div>
              </div>
              } @if (selectedFacility.last_request.to_group.performer) {
              <div class="detail-item">
                <div class="label">Performer</div>
                <div class="value">{{ selectedFacility.last_request.to_group.performer }}</div>
              </div>
              }
            </div>
            } @else {
            <div class="no-data">
              <mat-icon>info</mat-icon>
              No requests found to group from this facility
            </div>
            }
          </div>
        </div>
        <div class="facility-details">
          <!-- Basic Info -->
          <div class="detail-section">
            <h5 class="section-title">Basic Information</h5>
            <div class="detail-row">
              <span class="detail-label">Group:</span>
              <mat-chip-option
                class="group-chip"
                [style.background-color]="
                  getGroupColor(selectedFacility.activeReferralGroupsID)
                "
              >
                {{ getReferralGroupName(selectedFacility.activeReferralGroupsID) }}
              </mat-chip-option>
            </div>
            <div class="detail-row">
              <span class="detail-label">Practice Software:</span>
              <span class="detail-value">{{ selectedFacility.practiceSoftware }}</span>
            </div>
            @if (selectedFacility.InstallDate) {
            <div class="detail-row">
              <span class="detail-label">Install Date:</span>
              <span class="detail-value">
                {{ formatInstallDate(selectedFacility.InstallDate) }}
                <span class="time-ago-inline"
                  >({{ getInstallDaysAgo(selectedFacility) }})</span
                >
              </span>
            </div>
            } @if (selectedFacility.emails) {
            <div class="detail-row">
              <span class="detail-label">Emails:</span>
              <span class="detail-value">{{ selectedFacility.emails }}</span>
            </div>
            } @if (selectedFacility.medicalClinicEmail) {
            <div class="detail-row">
              <span class="detail-label">Medical Clinic Email:</span>
              <span class="detail-value">{{ selectedFacility.medicalClinicEmail }}</span>
            </div>
            }
            <div class="detail-row">
              <span class="detail-label">Agreements At:</span>
              <span class="detail-value">{{
                selectedFacility.agreements_at
                  ? (selectedFacility.agreements_at | date : 'dd/MM/yyyy HH:mm')
                  : 'N/A'
              }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Account Manager:</span>
              <span class="detail-value">{{
                selectedFacility.account_manager_name || 'N/A'
              }}</span>
            </div>
          </div>
          <!-- Address Section -->
          @if ( selectedFacility.street_address || selectedFacility.city ||
          selectedFacility.state || selectedFacility.postcode ) {
          <div class="detail-section">
            <h5 class="section-title">Address</h5>
            @if (selectedFacility.street_address) {
            <div class="detail-row">
              <span class="detail-label">Street Address:</span>
              <span class="detail-value">{{ selectedFacility.street_address }}</span>
            </div>
            } @if (selectedFacility.city) {
            <div class="detail-row">
              <span class="detail-label">City:</span>
              <span class="detail-value">{{ selectedFacility.city }}</span>
            </div>
            } @if (selectedFacility.state) {
            <div class="detail-row">
              <span class="detail-label">State:</span>
              <span class="detail-value">{{ selectedFacility.state }}</span>
            </div>
            } @if (selectedFacility.postcode) {
            <div class="detail-row">
              <span class="detail-label">Postcode:</span>
              <span class="detail-value">{{ selectedFacility.postcode }}</span>
            </div>
            }
          </div>
          }
          <!-- Practice Manager Section -->
          @if ( selectedFacility.practice_manager_name ||
          selectedFacility.practice_manager_email || selectedFacility.practice_manager_mobile )
          {
          <div class="detail-section">
            <h5 class="section-title">Practice Manager</h5>
            @if (selectedFacility.practice_manager_name) {
            <div class="detail-row">
              <span class="detail-label">Name:</span>
              <span class="detail-value">{{ selectedFacility.practice_manager_name }}</span>
            </div>
            } @if (selectedFacility.practice_manager_email) {
            <div class="detail-row">
              <span class="detail-label">Email:</span>
              <span class="detail-value">{{ selectedFacility.practice_manager_email }}</span>
            </div>
            } @if (selectedFacility.practice_manager_mobile) {
            <div class="detail-row">
              <span class="detail-label">Mobile:</span>
              <span class="detail-value">{{ selectedFacility.practice_manager_mobile }}</span>
            </div>
            }
          </div>
          }
          <!-- IT Technical Section -->
          @if ( selectedFacility.it_technical_name || selectedFacility.it_technical_email ||
          selectedFacility.it_technical_mobile ) {
          <div class="detail-section">
            <h5 class="section-title">IT Technical Contact</h5>
            @if (selectedFacility.it_technical_name) {
            <div class="detail-row">
              <span class="detail-label">Name:</span>
              <span class="detail-value">{{ selectedFacility.it_technical_name }}</span>
            </div>
            } @if (selectedFacility.it_technical_email) {
            <div class="detail-row">
              <span class="detail-label">Email:</span>
              <span class="detail-value">{{ selectedFacility.it_technical_email }}</span>
            </div>
            } @if (selectedFacility.it_technical_mobile) {
            <div class="detail-row">
              <span class="detail-label">Mobile:</span>
              <span class="detail-value">{{ selectedFacility.it_technical_mobile }}</span>
            </div>
            }
          </div>
          }
          <!-- Referral Group Requester Section -->
          @if ( selectedFacility.referral_group_requester_name ||
          selectedFacility.referral_group_requester_email ||
          selectedFacility.referral_group_requester_phone ) {
          <div class="detail-section">
            <h5 class="section-title">Referral Group Requester</h5>
            @if (selectedFacility.referral_group_requester_name) {
            <div class="detail-row">
              <span class="detail-label">Name:</span>
              <span class="detail-value">{{
                selectedFacility.referral_group_requester_name
              }}</span>
            </div>
            } @if (selectedFacility.referral_group_requester_email) {
            <div class="detail-row">
              <span class="detail-label">Email:</span>
              <span class="detail-value">{{
                selectedFacility.referral_group_requester_email
              }}</span>
            </div>
            } @if (selectedFacility.referral_group_requester_phone) {
            <div class="detail-row">
              <span class="detail-label">Phone:</span>
              <span class="detail-value">{{
                selectedFacility.referral_group_requester_phone
              }}</span>
            </div>
            }
          </div>
          }
          <!-- Timestamps Section -->
          <div class="detail-section">
            <h5 class="section-title">Record Information</h5>
            @if (selectedFacility.created_at) {
            <div class="detail-row">
              <span class="detail-label">Created:</span>
              <span class="detail-value">{{ formatDate(selectedFacility.created_at) }}</span>
            </div>
            } @if (selectedFacility.updated_at) {
            <div class="detail-row">
              <span class="detail-label">Last Updated:</span>
              <span class="detail-value">{{ formatDate(selectedFacility.updated_at) }}</span>
            </div>
            }
          </div>
          <div class="detail-section">
            <h5 class="section-title">Performers</h5>
            @if (selectedFacility.created_at) {
            <div class="detail-row">
              <span class="detail-label">Created:</span>
              <span class="detail-value">{{ formatDate(selectedFacility.created_at) }}</span>
            </div>
            } @if (selectedFacility.updated_at) {
            <div class="detail-row">
              <span class="detail-label">Last Updated:</span>
              <span class="detail-value">{{ formatDate(selectedFacility.updated_at) }}</span>
            </div>
            }
          </div>
          <!-- Agreement Link Section -->
          @if (selectedFacility.hash) {
          <div class="detail-section">
            <h5 class="section-title">Agreement Link</h5>
            <div class="detail-row">
              <span class="detail-label">Referral Agreement URL:</span>
              <div class="detail-value">
                <div class="agreement-link-display">
                  <a
                    [href]="
                      baseUrl + '/facility-management-agreement/' + selectedFacility.hash
                    "
                    target="_blank"
                    class="agreement-link"
                  >
                    {{ baseUrl }}/facility-management-agreement/{{ selectedFacility.hash }}
                  </a>
                </div>
                <p class="agreement-note">
                  This link should be sent to the referral group requester for terms
                  acceptance.
                </p>
              </div>
            </div>
          </div>
          }
          <div class="detail-section">
            <h5 class="section-title">Imaging Centres to receive e-Referrals</h5>
            @if (selectedFacility.created_at) {
            <div class="detail-row">
              <span class="detail-label">Performers:</span>
              <span class="detail-value">{{ selectedFacility.performer_names }}</span>
            </div>
            }
          </div>
          <div class="detail-section">
            <h5 class="section-title">Notes</h5>
            @if (selectedFacility.created_at) {
            <div class="detail-row">
              <span class="detail-label">Notes:</span>
              <span class="detail-value">{{ selectedFacility.notes }}</span>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
